import PropTypes from 'prop-types';
import React from 'react';

import DynamicForm from '../Common/DynamicForm/Form';
import * as styles from './FormBanner.module.css';
import MarketoForm from './MarketoForm/MarketoForm';
import PageSection from './PageSection';

const FormBanner = (props) => {
  const form = props.form ? (
    <DynamicForm form={props.form?.marketoForm} programName={props.form.marketoProgramName} />
  ) : (
    <MarketoForm key={props.formId} splitName={false} formId={props.formId} successMessage={props.successMessage} />
  );

  return (
    <PageSection
      slim={props.slim}
      className={[styles.wrap, props.dark ? styles.dark : '', props.className].join(' ')}
      id={'subscribe-form'}
    >
      <div className={styles.banner}>
        <h4>{props.heading}</h4>
        {form}
      </div>
    </PageSection>
  );
};

FormBanner.propTypes = {
  heading: PropTypes.string.isRequired,
  formId: PropTypes.string.isRequired,
  form: PropTypes.object,
  successMessage: PropTypes.string,
  dark: PropTypes.bool,
};

export default FormBanner;
